import React, { useState, useEffect } from "react";
import { Col, Row, FormGroup, Input, Label } from "reactstrap";
import { Bar } from "react-chartjs-2";
import Alert from "react-s-alert";
import { api } from "../helpers";
import _ from "lodash";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ProductionMetricsReport = props => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [data, setData] = useState(null);
  const [options, setOptions] = useState(null);
  const [title, setTitle] = useState("");

  const runReport = () => {
    api
      .post("Product/ProductionMetricsChartData", {
        StartDate: startDate,
        EndDate: endDate
      })
      .then(response => {
        if (response.data) {
          const reportData = {
            labels: response.data.labels,
            datasets: [
              {
                label: response.data.periodLabel,
                data: response.data.periodTotals.map(x => x.total),
                backgroundColor: "#4d73be"
              },
              {
                label: response.data.yearToDateLabel,
                data: response.data.averagesToDate.map(x => x.total),
                backgroundColor: "#8fa5d3"
              }
            ]
          };
          setData(reportData);

          const reportOptions = {
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  stacked: true,
                  ticks: {
                    beginAtZero: true
                  }
                }
              ],
              xAxes: [
                {
                  stacked: true
                }
              ]
            }
          };

          setOptions(reportOptions);
          setTitle(response.data.title);
        }
      })
      .catch(error => {
        Alert.error(
          "An error occurred when loading the production metrics report"
        );
      });
  };

  useEffect(
    () => {
      if (startDate && endDate) {
        runReport();
      }
    },
    [startDate, endDate]
  );

  return (
    <div className="ml-4 mr-4">
      <Row className="pageTitle p-2">
        <Col className="blueText">
          <h4>Production Metrics Report</h4>
        </Col>
      </Row>
      <Row className="rowSpacing cursor pl-2">
        <Col xs="2">
          <FormGroup>
            <Label>Start Date</Label>
            <DatePicker
              className="form-control"
              selected={startDate}
              onChange={date => setStartDate(date)}
            />
          </FormGroup>
        </Col>
        <Col xs="2">
          <FormGroup>
            <Label>End Date</Label>
            <DatePicker
              className="form-control"
              selected={endDate}
              onChange={date => setEndDate(date)}
            />
          </FormGroup>
        </Col>
      </Row>
      {data &&
        options && (
          <React.Fragment>
            <Row style={{ marginTop: "1rem", textAlign: "center" }}>
              <Col>
                <h3>{title}</h3>
              </Col>
            </Row>
            <Row style={{ marginTop: "1rem" }}>
              <Col style={{ maxHeight: "500px" }}>
                <Bar height={500} options={options} data={data} />
              </Col>
            </Row>
          </React.Fragment>
        )}
    </div>
  );
};

export default ProductionMetricsReport;



// WEBPACK FOOTER //
// ./src/components/ProductionMetricsReport.js